// Generate random marking pattern
const getRandomMarkedIndexes = (length: number): Set<number> => {
  const marked = new Set<number>();
  let i = 0;
  while (i < length) {
    marked.add(i);
    i += Math.random() < 0.5 ? 2 : 3;
  }
  return marked;
};

export { getRandomMarkedIndexes };
